module.exports = __webpack_public_path__ + "static/bg-highlight-home-31ae25ffa6059913e450566167639243.png";